import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CanvasJSReact from '@canvasjs/react-charts';
import './App.css';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const substations = [
  "SystemLoad", "107_01", "107_02", "107_03", "107_04", "107_05",
  "107_07", "107_08", "107_09", "107_10", "107_11", "107_12",
  "107_13", "107_14", "107_15", "107_16", "107_17", "107_18",
  "107_19", "107_20", "107_21", "107_22", "107_25", "71_12",
  "EMERSONGEN", "MERSONTOWN", "RATTLESNAKE", "WAKEFIELDGEN",
  "WAKEFIELDMAIN", "Winside_WAPA"
];

const getUnifiedAxisLimits = (data) => {
  const all = data.flatMap(item => {
    const vals = [];
    if (typeof item.y === 'number') vals.push(item.y);
    if (typeof item.y2 === 'number') vals.push(item.y2);
    return vals;
  });

  const min = Math.min(...all);
  const max = Math.max(...all);

  return {
    min: Math.floor(min * 0.95),
    max: Math.ceil(max * 1.05)
  };
};

const Home = () => {
  const [substationData, setSubstationData] = useState({});

  useEffect(() => {
    document.title = "Substation Load Dashboard";
    substations.forEach(fetchSubstation);
  }, []);

  const fetchSubstation = async (endpoint) => {
    try {
      const response = await axios.get(`/${endpoint}`);
      if (Array.isArray(response.data)) {
        const formattedData = response.data.map(item => ({
          x: new Date(item.TS),
          y: item.KW,
          y2: item.kVA ?? null,
          reporting: item.REPORTING
        }));
        setSubstationData(prev => ({ ...prev, [endpoint]: formattedData }));
      }
    } catch (err) {
      console.error(`Error fetching ${endpoint}`, err);
    }
  };

  const navigateToSystemInfo = () => {
    window.location.href = 'https://system.northeastpow.info';
  };

  const navigateToLargeLoad = () => {
    window.location.href = 'https://dashboard.northeastpow.info/Forms/largeload.html';
  };

const makeChartOptions = (title, data) => {
  const { min, max } = getUnifiedAxisLimits(data || []);

  return {
    zoomEnabled: true,
    theme: "light2",
    title: { text: `${title} Load` },
    axisX: {
      title: "Date",
      valueFormatString: "DD MMM YYYY"
    },
    axisY: {
      title: "KW",
      includeZero: false,
      minimum: min,
      maximum: max,
      /* stripLines: title === "SystemLoad" ? [
        {
          value: 65000,
          color: "red",
          label: "65 MW Control System Load",
          labelFontColor: "red",
          labelFontSize: 14,
          labelPlacement: "outside",
          thickness: 3
        }
      ] : [] */
    },
    axisY2: {
      title: "kVA",
      includeZero: false,
      minimum: min,
      maximum: max
    },
    data: [
      {
        type: "line",
        name: "KW",
        showInLegend: true,
        xValueFormatString: "DD MMM YYYY HH:mm",
        yValueFormatString: "#,##0.## KW",
        dataPoints: data?.map(item => ({
          x: item.x,
          y: item.y,
          reporting: item.reporting
        })) || [],
        toolTipContent: "Date: {x}<br/>KW: {y}<br/>Reporting: {reporting}<br/>"
      },
      {
        type: "line",
        name: "kVA",
        showInLegend: true,
        axisYType: "secondary",
        xValueFormatString: "DD MMM YYYY HH:mm",
        yValueFormatString: "#,##0.## kVA",
        dataPoints: data?.filter(item => item.y2 != null).map(item => ({
          x: item.x,
          y: item.y2,
          reporting: item.reporting
        })) || [],
        toolTipContent: "Date: {x}<br/>kVA: {y}<br/>"
      }
    ]
  };
};

  return (
    <div>
      <div className="header">
        <p>NORTHEAST POWER SUBSTATION LOAD</p>
        <p>65MW Control system load</p>
        <p>These graphs may take a minute to load</p>
      </div>
      <div className="button">
        <button onClick={navigateToSystemInfo}>Irrigation Load Dashboard</button>
        &nbsp;&nbsp;&nbsp;
        <button onClick={navigateToLargeLoad}>Large Load Dashboard</button>
      </div>
      <div className="charts-container">
        {substations.map(name => (
          <div className="chart-item" key={name}>
            <CanvasJSChart options={makeChartOptions(name, substationData[name])} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
